/*
	Google Analytics (GA4). Loaded only on the live site, so localhost and
	ngrok traffic never lands in the reports. whatboxart is a single-page app, so
	the initial gtag config is told NOT to send its own page view
	(send_page_view:false); instead the router sends one on every navigation
	(see router/index.js), so each in-app URL change counts as a page view.
*/

var ID = 'G-BG2M0YKT90'

// real visitors only — not localhost, an ngrok tunnel, or a local prod build
function live() {

	return window.location.hostname === 'boxart.geekgroup.app'

}

// the canonical gtag shim: queue args onto dataLayer for gtag.js to drain
function gtag() {

	window.dataLayer.push(arguments)

}

export default {

	init: function() {

		if (!live() || window.gtag) return

		window.dataLayer = window.dataLayer || []
		window.gtag = gtag

		var script = document.createElement('script')
		script.async = true
		script.src = 'https://www.googletagmanager.com/gtag/js?id=' + ID
		document.head.appendChild(script)

		window.gtag('js', new Date())
		// the SPA router sends page views itself, so don't auto-send one here
		window.gtag('config', ID, { send_page_view: false })

	},

	// a page view for the current URL — called on every route change. A no-op
	// off the live site (gtag is only defined there)
	pageview: function(path) {

		if (!window.gtag) return

		window.gtag('event', 'page_view', {
			page_path: path,
			page_location: window.location.href,
			page_title: document.title
		})

	}

}
